/* AJAX cart drawer */
(function () {
  "use strict";
  const drawer = document.getElementById('MzCartDrawer');
  if (!drawer) return;
  const openBtns = document.querySelectorAll('[data-mz-cart-open]');
  const closeBtns = document.querySelectorAll('[data-mz-cart-close]');
  const open = () => { drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
  const close = () => { drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  openBtns.forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
  closeBtns.forEach(b => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }
  async function renderDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } });
      if (res.ok) {
        const json = await res.json();
        if (json['cart-drawer']) {
          const tmp = document.createElement('div');
          tmp.innerHTML = json['cart-drawer'];
          const fresh = tmp.querySelector('#MzCartDrawer');
          if (fresh) { drawer.innerHTML = fresh.innerHTML; bindLineHandlers(); }
          return;
        }
      }
    } catch (_) {}
    const cart = await fetchCart();
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
  }
  async function addToCart(form) {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
    if (!res.ok) { console.warn('Add to cart failed'); return; }
    await renderDrawer();
    open();
  }
  async function updateLine(key, qty) {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    await renderDrawer();
  }
  function bindLineHandlers() {
    drawer.querySelectorAll('[data-line-item]').forEach(line => {
      const key = line.dataset.key;
      const input = line.querySelector('[data-qty-input]');
      const dec = line.querySelector('[data-qty-dec]');
      const inc = line.querySelector('[data-qty-inc]');
      const remove = line.querySelector('[data-qty-remove]');
      dec?.addEventListener('click', () => updateLine(key, Math.max(0, (parseInt(input.value, 10) || 0) - 1)));
      inc?.addEventListener('click', () => updateLine(key, (parseInt(input.value, 10) || 0) + 1));
      remove?.addEventListener('click', () => updateLine(key, 0));
      input?.addEventListener('change', () => updateLine(key, parseInt(input.value, 10) || 0));
    });
    drawer.querySelectorAll('[data-mz-cart-close]').forEach(b => b.addEventListener('click', close));
  }
  bindLineHandlers();
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });
  document.querySelectorAll('[data-quickadd]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const form = btn.closest('form');
      if (form && form.action.includes('/cart/add')) { e.preventDefault(); addToCart(form); }
    });
  });
})();
